import { useQuery } from '@tanstack/react-query'
import { api, type PatientAnalyticsParams } from '@/lib/api-client'

/**
 * Fetch patient analytics data for the Patients tab
 * Includes acquisition trends, visit frequency, top patients, and inactive alerts
 */
export function usePatientAnalytics(params?: PatientAnalyticsParams) {
  return useQuery({
    queryKey: ['analytics-patients', params?.branchId, params?.startDate, params?.endDate, params?.inactiveMonths],
    queryFn: () => api.analytics.patients(params),
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}
